export interface ITrackingConfiguration {
  module: string;
  tenantUUID: string;
}

export class ITrackingConfigurationService {
  public configuration: ITrackingConfiguration;
}
